import FormatDatesValueObject from "./FormatDatesValueObject";

export const formatDatesValueObject = (date: string) =>
  new FormatDatesValueObject(date);
